import { useMutation } from "@apollo/client/react";
import { useFormContext } from "react-hook-form";

import FlashContext from "components/FlashMessages/FlashContext";
import useTypedContext from "hooks/useTypedContext";
import { StateUploadUrl } from "types/generated";

import { GET_STATE_UPLOAD_URL } from "../Terraform/gql";
import { uploadFileToS3 } from "../Terraform/uploadFileToS3";
import { StackVendorFormFields } from "../../types";

export const useFileUpload = () => {
  const { onError } = useTypedContext(FlashContext);
  const { setValue, setError, clearErrors } = useFormContext<StackVendorFormFields>();
  const [getStateUploadUrl] = useMutation<{ stateUploadUrl: StateUploadUrl }>(GET_STATE_UPLOAD_URL);

  const handleStateFileChange = async (file: File | null) => {
    if (!file) {
      setValue("opentofu.uploadedStateFile", null);
      setValue("opentofu.uploadedStateObjectId", "", {
        shouldValidate: true,
      });
      clearErrors("opentofu.uploadedStateFile");

      return;
    }

    setValue("opentofu.uploadedStateFile", file);

    return getStateUploadUrl()
      .then(({ data }) => {
        if (data?.stateUploadUrl) {
          return Promise.all([
            data?.stateUploadUrl,
            uploadFileToS3(file, data?.stateUploadUrl?.url, data?.stateUploadUrl?.uploadHeaders),
          ]);
        }

        throw Error("Internal error");
      })
      .then(([stateUploadUrl]) => {
        setValue("opentofu.uploadedStateObjectId", stateUploadUrl.objectId, {
          shouldValidate: true,
        });
      })
      .catch((error) => {
        setValue("opentofu.uploadedStateObjectId", "", {
          shouldValidate: true,
        });

        setError("opentofu.uploadedStateFile", {
          message: "We had a problem processing your file",
        });

        onError(error);
      });
  };

  return handleStateFileChange;
};
